const FALLBACK_MESSAGE = 'Failed to deactivate model args';

/**
 * Turns the deactivate-model API error body into a user-facing toast message.
 *
 * The NestJS exception filter serializes a thrown exception as
 * `{ message: "<ClassName>Exception: <reason>" }`. We surface the reason (so the
 * admin sees "active template bundle(s) depend on it" rather than a generic
 * failure) and strip the leading `<ClassName>Exception:` prefix. Falls back to a
 * generic message when the body carries no readable string message.
 */
export const parseDeactivateErrorMessage = (body: unknown): string => {
  const serverMessage =
    typeof body === 'object' &&
    body !== null &&
    'message' in body &&
    typeof (body as { message: unknown }).message === 'string'
      ? (body as { message: string }).message
      : null;

  if (!serverMessage) {
    return FALLBACK_MESSAGE;
  }

  return serverMessage.replace(/^[A-Za-z]+Exception:\s*/, '');
};
